import type { SidebarSection } from './sidebar-items';
import { SidebarNavItem } from './SidebarNavItem';
import styles from './Sidebar.module.css';

export const SidebarNavSection = ({
  section,
  activeItem,
}: {
  section: SidebarSection;
  activeItem: string;
}) => (
  <div className={styles.section}>
    <h2>{section.label}</h2>
    <ul>
      {section.items.map(item => (
        <SidebarNavItem key={item.id} item={item} activeItem={activeItem} />
      ))}
    </ul>
  </div>
);
